export enum AlarmCentralType {
    Primary = 0,
    Secondary = 1,
    Tertiary = 2,
}
